// extracted by mini-css-extract-plugin
export default {"image":"DeviceSelection_image__wA6+0","container":"DeviceSelection_container__61nJQ","decription":"DeviceSelection_decription__-6rsb"};